import { render, staticRenderFns } from "./staffEdit.vue?vue&type=template&id=f489b20a&scoped=true&"
import script from "./staffEdit.vue?vue&type=script&lang=js&"
export * from "./staffEdit.vue?vue&type=script&lang=js&"
import style0 from "./staffEdit.vue?vue&type=style&index=0&id=f489b20a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f489b20a",
  null
  
)

export default component.exports